import {
    onAddToCart,
    onViewItem,
    onItemSelect,
} from '@gtmcustom/gtm/gtmEvents';
import Resource from '@assets/utils/resource';
import { getSubTotal, getQuantityInCart } from './gtmUtils';

export default class PdpGTMEvents {
    constructor() {
        this.select_item = null;
        this.product = window.pdpProduct;
        this.subTotal = 0;
    }

    init() {
        if (!Resource.getSitePreference('google', 'googleTagManagerEnabled')) return;
        this.onAddToCart();
        this.onPDPLoad();
        this.onAttributeSelect();
    }

    onAddToCart() {
        const self = this;
        $('body').on('product:afterAddToCart', (event, data) => {
            const subtotal = parseFloat(
                data.cart.totals.subTotal.replace('€', '').replace(',', '.'),
                2,
            );
            const pidValue = data.productIdAdded;
            if (pidValue) {
                const [product] = data.cart.items.filter((item) => item.id === pidValue);
                if (product) {
                    self.product[0].quantity = product.quantity;
                }
            }
            self.subTotal = subtotal;
            onAddToCart(self.product, subtotal);
        });
    }

    onPDPLoad() {
        const self = this;
        $(window).on('load', async () => {
            self.getAndClearSessionStorage();
            self.subTotal = await getSubTotal();
            onViewItem(
                self.product,
                self.subTotal,
            );
            if (self.select_item) {
                onItemSelect(self.product);
            }
        });
    }

    getAndClearSessionStorage() {
        this.select_item = JSON.parse(sessionStorage.getItem('item_select'));
        if (!this.select_item) return;
        if (this.select_item[0].product.item_id === this.product[0].item_id) {
            this.product[0].index = this.select_item[0].product.index;
            this.product[0].item_list_id = this.select_item[0].item_list_id;
            this.select_item[0] = this.product[0].product;
        }
        sessionStorage.removeItem('item_select');
    }

    onAttributeSelect() {
        const self = this;
        $('body').on('product:afterAttributeSelect', async (event, response) => {
            const newProduct = response.data.product;
            self.product[0].item_name = newProduct.productName;
            const [newSku] = newProduct.customAttributes.filter((attribute) => attribute.id === 'sku')[0].value;
            self.product[0].item_variant = newSku;
            let fullPrice;
            if (newProduct.price.type && newProduct.price.type === 'range') {
                self.product[0].price = newProduct.price.max.sales.value;
                fullPrice = newProduct.price.max.sales.value;
            } else {
                self.product[0].price = newProduct.price.sales.value;
                fullPrice = !newProduct.price.list ? newProduct.price.sales.value : newProduct.price.list.value;
            }
            self.product[0].full_price = fullPrice === self.product[0].price;
            self.product[0].quantity = await getQuantityInCart(newProduct.id);
            [self.product[0].stock_status] = newProduct.availability.messages;
            window.pdpProduct = self.product;
            onViewItem(
                self.product,
                self.subTotal,
            );
        });
    }
}
